<template>
  <div v-if="pro && pro.connections?.length" class="flex flex-col gap-6">
    <div
      class="flex flex-wrap text-13 font-semibold text-grayscale-96 leading-130"
    >
      <span
        v-for="artist in connectionsFirsts"
        :key="artist"
        class="py-2.5 px-5 rounded-3 mr-2 mb-2 border border-grayscale-80"
        >{{ artist }}</span
      >
      <button
        v-if="connectionsRest?.length && !showAllConnections"
        class="py-2.5 px-5 rounded-3 mr-2 mb-2 border border-grayscale-80 flex items-center gap-2"
        @click="showAllConnections = true"
      >
        <span>{{ connectionsRest.length }} more</span>
        <i class="icon-down text-grayscale-96 text-16 leading-4"></i>
      </button>
      <span
        v-if="showAllConnections"
        v-for="artist in connectionsRest"
        :key="artist"
        class="py-2.5 px-5 rounded-3 mr-2 mb-2 border border-grayscale-80"
        >{{ artist }}</span
      >
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import type { PropType } from "vue";
import type { User } from "../../../types/user";

const props = defineProps({
  pro: {
    type: Object as PropType<User>,
    required: true,
  },
});

const connectionsFirsts = ref(props.pro.connections?.slice(0, 4));
const connectionsRest = ref(props.pro.connections?.slice(4));
const showAllConnections = ref(false);
</script>
